import createSubscription from './createSubscription'

const CHANNEL_NAME = 'NotificationsChannel'

$(() => {
  createSubscription(CHANNEL_NAME, (data) => {
    $('#notifications').append(data.html)
  })
})
